export default __webpack_public_path__ + "static/media/aircraft_plant_3.1fc06bdd.png";